var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-button',_vm._g(_vm._b({staticClass:"ant-blue-button",attrs:{"color":_vm.antBlue,"data-mu-loading-size":"24"}},'mu-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }